/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  DevicesAPIRes,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnDevicesAPIInput {
  deviceId?: number;
}
const build = (_query: DocumentNode, input: OnDevicesAPIInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: Float = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onDevicesAPI(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' }
    ){
      ...devicesapires
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnDevicesAPISubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment devicesapires on DevicesAPIRes { ... }
   */
  execute(_query: DocumentNode, input: OnDevicesAPIInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onDevicesAPI : Partial<DevicesAPIRes>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
